import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { AuditLogFilters, auditLogsApi } from '@/services';

export const auditLogsKeys = {
  all: ['admin', 'audit-logs'] as const,
  list: (filters: AuditLogFilters) => [...auditLogsKeys.all, 'list', filters] as const,
};

export function useAuditLogsListQuery(filters: AuditLogFilters) {
  return useQuery({
    queryKey: auditLogsKeys.list(filters),
    queryFn: () => auditLogsApi.list(filters),
    placeholderData: keepPreviousData,
  });
}
